module.exports = __webpack_public_path__ + "images/section-bg-12-small.webp";